// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BackupDump } from './BackupDump';
import {
  BackupDumpFromJSON,
  BackupDumpFromJSONTyped,
  BackupDumpToJSON,
  BackupDumpToJSONTyped,
} from './BackupDump';
import type { BackupBackup } from './BackupBackup';
import {
  BackupBackupFromJSON,
  BackupBackupFromJSONTyped,
  BackupBackupToJSON,
  BackupBackupToJSONTyped,
} from './BackupBackup';

/**
 *
 * @export
 * @interface BackupSnapshots
 */
export interface BackupSnapshots {
  /**
   *
   * @type {Array<BackupBackup>}
   * @memberof BackupSnapshots
   */
  backups?: Array<BackupBackup>;
  /**
   *
   * @type {Array<BackupDump>}
   * @memberof BackupSnapshots
   */
  dumps?: Array<BackupDump>;
}

/**
 * Check if a given object implements the BackupSnapshots interface.
 */
export function instanceOfBackupSnapshots(
  value: object,
): value is BackupSnapshots {
  return true;
}

export function BackupSnapshotsFromJSON(json: any): BackupSnapshots {
  return BackupSnapshotsFromJSONTyped(json, false);
}

export function BackupSnapshotsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BackupSnapshots {
  if (json == null) {
    return json;
  }
  return {
    backups:
      json['backups'] == null
        ? undefined
        : (json['backups'] as Array<any>).map(BackupBackupFromJSON),
    dumps:
      json['dumps'] == null
        ? undefined
        : (json['dumps'] as Array<any>).map(BackupDumpFromJSON),
  };
}

export function BackupSnapshotsToJSON(json: any): BackupSnapshots {
  return BackupSnapshotsToJSONTyped(json, false);
}

export function BackupSnapshotsToJSONTyped(
  value?: BackupSnapshots | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    backups:
      value['backups'] == null
        ? undefined
        : (value['backups'] as Array<any>).map(BackupBackupToJSON),
    dumps:
      value['dumps'] == null
        ? undefined
        : (value['dumps'] as Array<any>).map(BackupDumpToJSON),
  };
}
